import { VideoApi } from '@bpm-web-app/download-api-sdk';
import { downloadConfig } from '../../config';
import { GenericPaginatedQuery } from '../../typings/search-query';

export class Video {
    static client = new VideoApi(downloadConfig);

    static getVideos = (query: GenericPaginatedQuery) =>
        Video.client.getVideos(query.limit, query.skip);

    static getVideoCategories = () =>
        Video.client.getVideoCategories();

    static getFeaturedVideos = () =>
        Video.client.getFeaturedVideos();

    static getVideosForCategory = (slug: string) =>
        Video.client.getVideosByCategorySlug(slug);

    static getVideoBySlug = (slug: string) =>
        Video.client.getVideoBySlug(slug);
}
